define('config/extensions/nativeComposition',[],function () {

    return {

        services: {

            GameRunner: {
                module: 'gameBrowser/GameRunner',
                init: 'partial',
                args: [
                    'LOG',
                    '@session',
                    '@settings',
                    'PlatformCmd:launchGame:common',
                    '@GameProviderModel',
                    '@nativeMessages.launchGame'
                ]
            },

            // override login page with new functionality
            commonLoginViewModel: {
                module: 'viewmodels/pages/login',
                args: [
                    '@loginModel',
                    'fe:wp:page:root:mobile/sign-in',
                    '@navigation',
                    '@vocabulary',
                    '@sessionHistory',
                    '@ChooseAccountDialog',
                    '@ForgotPasswordDialog',
                    '@ChoiceAlert',
                    '@formFields',
                    'publish:onLoginPageActivated'
                ]
            },

            loginViewModel: {
                module: 'native/viewmodels/Login',
                args: [
                    '@commonLoginViewModel',
                    '@touchIdModel',
                    'wp:page:root:mobile/touch-id-setup',
                    '@nativeMessenger',
                    '@nativeMessageChannels'
                ],
                extras: [
                    {
                        subscribe: {
                            handleNoLoggedOutFreeplay: 'handleNoLoggedOutFreeplay'
                        }
                    }
                ]
            },

            nativeMessenger: {
                module: 'native/NativeLayerMessenger',
                args: ['LOG']
            },

            nativeMessageChannels: {
                module: 'native/NativeMessageChannels',
                init: 'return'
            },

            nativeMessages: {
                module: 'native/Messages',
                args: ['@nativeMessenger', '@imageOptimizer', '@nativeMessageChannels'],
                extras: [
                    {
                        subscribe: {
                            onLoginFailed: 'loginError',
                            onLoginDataAccepted: 'playerLogin',
                            onAppComposed: 'appLoaded'
                        }
                    }
                ]
            },

            nativeApi: {
                module: 'native/Api',
                init: 'partial',
                args: [
                    'LOG',
                    '@session',
                    '@gameLauncher',
                    '@GameRunner',
                    '@gamesInterface',
                    '@gameRoundDelay',
                    '@navigation',
                    '@referrerInfo',
                    '@loginModel',
                    '@touchIdSetupDialog'
                ],
                extras: [
                    {
                        subscribe: 'afterAppStart'
                    }
                ]
            },

            nativeNotifications: {
                module: 'native/NativeNotifications',
                init: 'partial',
                args: ['@session', '@gameLauncher', '@nativeMessenger', '@nativeMessageChannels'],
                extras: [
                    {
                        subscribe: 'afterAppStart'
                    }
                ]
            },

            touchIdModel: {
                module: 'native/models/TouchIdModel',
                args: ['@localStorageAccessorFactory', '@session', '@loginModel']
            },

            touchId: {
                module: 'native/TouchId',
                args: [
                    '@touchIdSetupDialog',
                    '@touchIdSettingViewModel',
                    '@touchIdModel',
                    '@nativeMessenger',
                    '@nativeMessageChannels',
                    '@loginModel',
                    '@loginViewModel'
                ],
                extras: [
                    {
                        subscribe: {
                            onCanReceivePluggableSettings: 'addTouchIdSetting',
                            onLoginDataAccepted: 'showTouchIdSetupIfNeeded',
                            onLoginPageActivated: 'loginPageActivated',
                            onLogout: 'removeUnusedCredentials'
                        }
                    }
                ]
            },

            touchIdSetupDialog: {
                module: 'native/viewmodels/TouchIdSetupDialog',
                args: [
                    '@plugins/dialog',
                    '@nativeMessenger',
                    '@nativeMessageChannels',
                    'wp:page:root:mobile/touch-id-setup'
                ]
            },

            touchIdSettingViewModel: {
                module: 'native/viewmodels/TouchIdSetting',
                args: ['@touchIdSetupDialog','@touchIdModel']
            }
        }
    };
});


